import React, { useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const NAV = [
  { to: '/', label: 'داشبورد', icon: '🏠', exact: true },
  { to: '/sales', label: 'فروشات', icon: '🛒' },
  { to: '/customers', label: 'مشتریان', icon: '👥' },
  { to: '/products', label: 'انبار', icon: '📦' },
  { to: '/loans', label: 'وام‌ها', icon: '💳' },
  { to: '/expenses', label: 'مصارف شرکا', icon: '💼' },
];

export default function Layout() {
  const { user, logout, isAdmin } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleLogout = () => { logout(); navigate('/login'); };

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      {/* Sidebar */}
      <aside style={{
        width: 240, background: 'var(--sidebar)', color: 'white',
        display: 'flex', flexDirection: 'column', flexShrink: 0,
        position: 'fixed', height: '100vh', right: 0, top: 0, zIndex: 100
      }}>
        <div style={{ padding: '24px 20px', borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
          <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 4 }}>🌾 فروشگاه محمدی</div>
          <div style={{ fontSize: 12, opacity: 0.7 }}>مواد خوارکی</div>
        </div>

        <nav style={{ flex: 1, padding: '12px 0', overflowY: 'auto' }}>
          {NAV.map(item => (
            <NavLink key={item.to} to={item.to} end={item.exact}
              style={({ isActive }) => ({
                display: 'flex', alignItems: 'center', gap: 10,
                padding: '11px 20px', color: isActive ? 'white' : 'rgba(255,255,255,0.7)',
                background: isActive ? 'rgba(255,255,255,0.12)' : 'transparent',
                textDecoration: 'none', fontSize: 14, fontWeight: isActive ? 600 : 400,
                borderRight: isActive ? '3px solid #e67e22' : '3px solid transparent',
                transition: 'all 0.2s'
              })}>
              <span>{item.icon}</span> {item.label}
            </NavLink>
          ))}
          {isAdmin && (
            <NavLink to="/users"
              style={({ isActive }) => ({
                display: 'flex', alignItems: 'center', gap: 10,
                padding: '11px 20px', color: isActive ? 'white' : 'rgba(255,255,255,0.7)',
                background: isActive ? 'rgba(255,255,255,0.12)' : 'transparent',
                textDecoration: 'none', fontSize: 14, fontWeight: isActive ? 600 : 400,
                borderRight: isActive ? '3px solid #e67e22' : '3px solid transparent',
              })}>
              <span>⚙️</span> مدیریت کاربران
            </NavLink>
          )}
        </nav>

        <div style={{ padding: '16px 20px', borderTop: '1px solid rgba(255,255,255,0.1)' }}>
          <div style={{ fontSize: 13, opacity: 0.8, marginBottom: 2 }}>{user?.name}</div>
          <div style={{ fontSize: 11, opacity: 0.5, marginBottom: 10 }}>
            {user?.role === 'admin' ? '👑 ادمین' : '👤 کاربر'}
          </div>
          <button onClick={handleLogout} className="btn btn-outline"
            style={{ width: '100%', color: 'rgba(255,255,255,0.8)', borderColor: 'rgba(255,255,255,0.3)', fontSize: 13 }}>
            🚪 خروج
          </button>
        </div>
      </aside>

      {/* Main */}
      <main style={{ marginRight: 240, flex: 1, padding: '28px 24px', minHeight: '100vh' }}>
        <Outlet />
      </main>
    </div>
  );
}
